@if(config?.hintText) {
    <div class="statusbar" (click)="openLink(config!.hintUrl)">
        <div class="statusbar-content">{{config?.hintText}}</div>
        <div class="statusbar-button"></div>
    </div>  
}